module.exports = "<div class=\"item\">\r\n\t<h4 class=\"item-title\"><%= data.title %></h4>\r\n\t<p class=\"item-text\"><%= _.escape(data.text).replace(/\\n/g, '<br />') %></p>\r\n\t<div class=\"item-date\">\r\n\t\t<span class=\"item-date\"><%- new Date(data.created).toLocaleDateString() %></span>\r\n\t\t<!--<% if (data.updated) { %>\r\n\t\t\t<span class=\"item-date\">Actualizada: <%- new Date(data.updated).toLocaleDateString() %></span>\r\n\t\t<% } %>-->\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/news-section/news-item/news-item.tpl.html
// module id = 126
// module chunks = 0